<template>
    <b-modal id="workingModal" :title="title" size="lg">
        <div class="details" id="printArea">            
            <div class="details_box">
                <div class="print_table">
                    <table>
                        <colgroup>
                            <col width="200px">
                            <col width="*">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th ><span>코끼리 원외탕전실</span></th>
                                <td class="ac fwb" colspan="100%"><span>조제지시 및 작업일지</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="print_table">
                    <table>
                        <caption  align="top">1. 조제지시</caption>
                        <tbody>                         
                            <tr>
                                <th><span  >처방기관</span></th>
                                <td colspan="3"><span class="font_red">{{pharmacyInfo.clinic_nm}} {{pharmacyInfo.doctor_nm}}</span></td>
                                <th><span >조제번호</span></th>
                                <td colspan="5"><span>{{pharmacyInfo.prescribe_seq}}</span></td>
                            </tr>
                            <tr>
                                <th><span >환자명</span></th>
                                <td colspan="3"><span>{{pharmacyInfo.patient_nm}}</span></td>
                                <th><span >조제일</span></th>
                                <td colspan="5"><span>{{pharmacyInfo.currentDay}}</span></td>
                            </tr>
                            <!-- <tr>
                                <th ><span>제형</span></th>
                                <td  colspan="3"><span>탕 제</span></td>
                                <th><span>복용기한</span></th>
                                <td colspan="5"><span></span></td>
                            </tr> -->
                            <tr>
                                <th><span >주문정보</span></th>
                                <td colspan="3">
                                    <span v-if="pharmacyInfo.prescribe_type == 'T'">조제 및 탕전 일반탕전</span>
                                    <span v-else-if="pharmacyInfo.prescribe_type == 'I'">조제 및 탕전 첩약탕전</span>
                                </td>
                                <th><span >조제자</span></th>
                                <td colspan="5"><span>김봉준</span></td>
                            </tr>
                            <tr>
                                <th><span >배송정보</span></th>
                                <td colspan="3"><span>{{pharmacyInfo.delivery_type_nm}}</span></td>
                                <th><span >발송일자</span></th>
                                <td colspan="5"><span>{{pharmacyInfo.currentDay}}</span></td>
                            </tr>       
                            <tr>
                                <th><span >보내는주소</span></th>
                                <td colspan="9"><span>[{{pharmacyInfo.send_post_no}}] {{pharmacyInfo.send_addr}} {{pharmacyInfo.send_addr_dtl}}</span></td>
                            </tr> 
     
                            <tr>
                                <th><span >받는주소</span></th>
                                <td colspan="9"><span>[{{pharmacyInfo.receive_post_no}}] {{pharmacyInfo.receive_addr}} {{pharmacyInfo.receive_addr_dtl}}</span></td>
                            </tr>
                            <tr>
                                <th><span >후하약재</span></th>
                                <td colspan="9"><span>{{pharmacyInfo.prescribe_note}}</span></td>
                            </tr>
                            <tr>
                                <th><span >조제지시</span></th>
                                <td colspan="9"><span class="font_red">{{pharmacyInfo.prepare_order}}</span></td>
                            </tr>                                                                               
                            <!-- <tr>
                                <th><span>처방명</span></th>
                                <td colspan="3"><span>{{pharmacyInfo.prescribe_nm}}</span></td>
                                <th><span>팩수</span></th>
                                <td ><span>{{pharmacyInfo.packs_cnt}}팩</span></td>
                                <th><span>팩 용량</span></th>
                                <td ><span>{{pharmacyInfo.pack_capacity}}ml</span></td>
                                <th><span>첩수</span></th>
                                <td><span>{{pharmacyInfo.prescribe_pack_cnt}}</span></td>
                            </tr>                        -->
                        </tbody>
                    </table>
                </div>
                <!-- <div class="print_table pb0">
                    <table>
                        <caption  align="top">2. 처방내용 : 세부내역 참조</caption>
                    </table>
                </div> -->
                <div class="print_table">
                    <table>
                        <caption  align="top">2. 공정 기록</caption>
                        <thead>
                            <tr>
                                <th><span >공정</span></th>
                                <th colspan="6"><span >공 정 세 부 사 항</span></th>
                                <th><span >확인자</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td rowspan="2"><span >① 조제</span></td>
                                <td class="highlight-span"><span>감미제</span></td>
                                <td class="highlight-span"><span>향기</span></td>
                                <td class="highlight-span"><span>조제 총량</span></td>
                                <td colspan="2" class="highlight-span"><span>조제시간</span></td>
                                 <td class="highlight-span"><span>조제장소</span></td>
                                <td rowspan="2">
                                    <span class="font_small_size">{{pharmacyInfo.currentDay}}</span><br>
                                    <span class="font_small_size">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;시&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;분</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span v-if="pharmacyInfo.sweetener == 0">없음</span>
                                    <span v-if="pharmacyInfo.sweetener == 1"> 약간단맛 </span>
                                    <span v-if="pharmacyInfo.sweetener == 2"> 단맛 </span>
                                    <span v-if="pharmacyInfo.sweetener == 3"> 중간단맛 </span>
                                    <span v-if="pharmacyInfo.sweetener == 4"> 매우단맛 </span>
                                </td>
                                 <td>
                                    <span v-if="pharmacyInfo.sweet_flavor == ''">없음</span>
                                    <span v-if="pharmacyInfo.sweet_flavor == 'CA1'"> 약한카라멜향(0.5%) </span>
                                    <span v-if="pharmacyInfo.sweet_flavor == 'CA2'"> 약한카라멜향(1%) </span>
                                    <span v-if="pharmacyInfo.sweet_flavor == 'SB1'"> 약한딸기향(0.5%) </span>
                                    <span v-if="pharmacyInfo.sweet_flavor == 'SB1'"> 약한딸기향(1%) </span>
                                    <span v-if="pharmacyInfo.sweet_flavor == 'CH1'"> 약한초코향(0.5%) </span>
                                    <span v-if="pharmacyInfo.sweet_flavor == 'CH2'"> 약한초코향(1%) </span>
                                </td>
                                <td><span>{{pharmacyInfo.total_medicine_qnty}} g</span></td>
                                <td colspan="2">
                                    <!-- <span>{{fn_current_time()}}</span>  -->
                                </td>
                                <td>
                                    <span>조제실</span>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2"><span >② 추출</span></td>
                                <td class="highlight-span"><span >추출물량</span></td>
                                <td class="highlight-span"><span >투입물량</span></td>
                                <td class="highlight-span"><span >탕전방식</span></td>
                                <td class="highlight-span"><span >탕전시간(분)</span></td>
                                <td class="highlight-span"><span >추출용매</span></td>
                                <td class="highlight-span"><span >작업내용</span></td>
                                <td rowspan="2">
                                    <span class="font_small_size">{{pharmacyInfo.currentDay}}</span><br>
                                    <span class="font_small_size">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;시&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;분</span>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{pharmacyInfo.requiredAmount}} g</span></td>
                                <td><span class="font_red">{{pharmacyInfo.amountWater}} ml</span></td>
                                <td>
                                    <span v-if="pharmacyInfo.pressure_yn == 'Y'" class="font_red">압력</span>
                                    <span v-else class="font_red">무압력</span>
                                </td>
                                <td>
                                    <span>선전 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)분</span><br>
                                    <span>탕전 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)분</span><br>
                                    <span>후하 (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)분</span>
                                </td>
                                <td><span>정제수</span></td>
                                <td><span>탕전기번호</span><br><br><span>탕전완료시간</span><br><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;시&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;분</span></td>
                            </tr>
                            <!-- <tr>
                                <td><span>③ 세척</span></td>
                                <td><span></span></td>
                                <td><span></span></td>
                                <td><span></span></td>
                                <td><span></span></td>
                            </tr> -->
                            <tr>
                                <td rowspan="2"><span >③ 파우치 포장</span></td>
                                <td class="highlight-span"><span >파우치</span></td>
                                <td class="highlight-span"><span >팩당용량</span></td>
                                <td class="highlight-span"><span >팩수</span></td>
                                <td colspan="2" class="highlight-span"><span>파우치포장시간</span></td>
                                <td class="highlight-span"><span >포장기번호</span></td>
                                <td rowspan="2">
                                    <span class="font_small_size">{{pharmacyInfo.currentDay}}</span><br>
                                    <span class="font_small_size">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;시&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;분</span>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="font_red">{{pharmacyInfo.pouch_wraaper_nm}}</span></td>
                                <td><span class="font_red">{{pharmacyInfo.pack_capacity}}ml</span></td>
                                <td><span class="font_red">{{pharmacyInfo.packs_cnt}}</span></td>
                                <td colspan="2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;시&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;분</td>
                                <td><span></span></td>
                            </tr>
                            <!-- <tr>
                                <td><span>⑤ 세척</span></td>
                                <td><span></span></td>
                                <td><span></span></td>
                                <td><span></span></td>
                                <td><span></span></td>
                            </tr> -->
                            <tr>
                                <td rowspan="2"><span >④ 외포장 및 배송</span></td>
                                <td class="highlight-span"><span >포장</span></td>
                                <td class="highlight-span"><span >박스</span></td>
                                <td class="highlight-span"><span >복용법</span></td>
                                <td class="highlight-span" colspan="2"></td>
                                <td class="highlight-span"><span >외부포장</span></td>
                                <td rowspan="2">
                                    <span class="font_small_size">{{pharmacyInfo.currentDay}}</span><br>
                                    <span class="font_small_size">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;시&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;분</span>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="font_blue">{{pharmacyInfo.wrapper_type_nm}}</span></td>
                                <td><span class="font_blue">{{pharmacyInfo.box_wrapper_nm}}</span></td>
                                <td>
                                    <span v-if="pharmacyInfo.take_way != '' || pharmacyInfo.take_way_file_id != null" class="font_blue">있음</span>
                                    <span v-else class="font_blue">없음</span>
                                </td>
                                <td colspan="2"></td>
                                <td><span></span></td>  
                            </tr>
                            <tr>
                                <td><span >⑤ 마킹 내용</span></td>
                                <td colspan="6">
                                    <span v-if="pharmacyInfo.mark_yn == 'Y'" class="font_blue">이름,날짜</span>
                                    <span v-else class="font_blue">없음</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="print_table">
                    <table>
                        <caption  align="top">4. 포장요구사항</caption>
                        <tbody>
                            <tr>
                                <td colspan="100%" class="minHeight"><span class="img font_blue">{{pharmacyInfo.wrapper_req}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="print_table">
                    <table>
                        <caption  align="top">5. 배송메모</caption>
                        <tbody>
                            <tr>
                                <td colspan="100%" class="minHeight"><span class="img">{{pharmacyInfo.delivery_memo}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="details_box">
                <div class="print_table">
                    <table>
                        <tbody>
                            <tr>
                                <th><span >#.{{pharmacyInfo.prescribe_seq}}</span></th>
                                <td colspan="4"><span>처방전</span></td>
                                <th><span  >처방 일자</span></th>
                                <td colspan="4"><span>{{pharmacyInfo.prescribe_dt}}</span></td>
                            </tr>
                            <tr>
                                <th><span >환자명</span></th>
                                <td colspan="4"><span>{{pharmacyInfo.patient_nm}} ({{pharmacyInfo.patient_gender_nm}}) ({{pharmacyInfo.patient_age}}세)</span></td>
                                <th><span >한의원명</span></th>
                                <td colspan="4"><span>{{pharmacyInfo.clinic_nm}} {{pharmacyInfo.doctor_nm}}</span></td>
                            </tr>
                            <tr>
                                <th><span >환자 연락처</span></th>
                                <td colspan="4"><span>{{formatPhoneNumber(pharmacyInfo.patient_tel_num)}}</span></td>
                                <th><span >한의원전화</span></th>
                                <td colspan="4"><span>{{formatPhoneNumber(pharmacyInfo.clinic_tel_num)}}</span></td>                                
                            </tr>
                            <tr>
                                <th><span >배송방식</span></th>
                                <td colspan="4"><span>{{pharmacyInfo.delivery_type_nm}}</span></td>
                                <th><span >발송일자</span></th>
                                <td colspan="4"><span>{{pharmacyInfo.currentDay}}</span></td>                            
                            </tr>
                            <tr>
                                <td colspan="100%"><span>[{{pharmacyInfo.receive_post_no}}] {{pharmacyInfo.receive_addr}} {{pharmacyInfo.receive_addr_dtl}}</span></td>
                            </tr>
                            <tr>
                                <th><span >주문정보</span></th>
                                <td colspan="5">
                                    <span v-if="pharmacyInfo.prescribe_type == 'T'">조제 및 탕전 일반탕전</span>
                                    <span v-else-if="pharmacyInfo.prescribe_type == 'I'">조제 및 탕전 첩약탕전</span>
                                </td>
                                <th><span >복용법</span></th>
                                <td colspan="3">
                                    <span v-if="pharmacyInfo.take_way != '' || pharmacyInfo.take_way_file_id != null">있음</span>
                                    <span v-else>없음</span>
                                </td>
                            </tr>
                            <tr>
                                <th><span >처방명</span></th>
                                <td colspan="3"><span>{{pharmacyInfo.prescribe_nm}}</span></td>
                                <th><span >팩수</span></th>
                                <td><span>{{pharmacyInfo.packs_cnt}}팩</span></td>
                                <th><span >팩 용량</span></th>
                                <td><span>{{pharmacyInfo.pack_capacity}}ml</span></td>
                                <th><span >첩수</span></th>
                                <td><span>{{pharmacyInfo.prescribe_pack_cnt}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="print_table pt0">
                    <div class="df_table bn">
                        <div class="print_table pt0" v-for="(medList, index) in splitMedList" :key="index">
                            <table>
                                <colgroup>
                                    <col width="50">
                                    <col width="*">
                                    <col width="50">
                                    <col width="50">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th colspan="2"><span>품목</span></th>
                                        <th><span>용량</span></th>
                                        <th><span>누적량</span></th>
                                    </tr>
                                    <tr v-for="(item, idx) in medList" :key="idx">
                                        <th><span>{{ item.num }}</span></th>
                                        <td ><span v-if="item.tangen_way == 'B'" class="font_blue">{{ item.medName }}</span>
                                             <span v-else-if="item.tangen_way == 'A'" class="font_red">{{ item.medName }}</span>
                                             <span v-else>{{ item.medName }}</span>
                                            <span v-if="item.orgPlceNm != ''" class="pl5"> [{{item.orgPlceNm}}]</span>
                                            <span v-if="item.tangen_way == 'B'" class="font_blue pl5"> / 선전</span>
                                             <span v-else-if="item.tangen_way == 'A'" class="font_red pl5">/ 후하</span>
                                        </td>
                                        <td>
                                            <span v-if="item.useQy != '-'">{{ Math.round(item.useQy * pharmacyInfo.prescribe_pack_cnt)}} g</span>
                                            <span v-else>{{ item.useQy }}</span>
                                        </td>
                                        <td>
                                            <span>{{item.cumulative}}</span>    
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="print_table_01">
                    <table>
                        <colgroup>
                            <col width="90px">
                            <col width="35%">
                            <col width="90px">
                            <col width="*">
                        </colgroup>
                        <tfoot>
                            <tr>
                                <td><span >투입 물량</span></td>
                                <td colspan="2"><span>{{pharmacyInfo.amountWater}}cc</span></td>
                                <td class="ar fwb"><span>총조제량</span></td>
                                <td class="ar"><span><strong>{{pharmacyInfo.total_medicine_qnty}}</strong></span></td>
                            </tr>
                            <tr>
                                <th><span >조제지시</span></th>
                                <td colspan="4" class="minHeight font_red"><span>{{pharmacyInfo.prepare_order}}</span></td>
                            </tr>  
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer>
            <b-button class="btn btn_md btn_darkblue" @click="print">출력</b-button>
            <b-button  class="btn btn_md btn_brown" @click="fn_close">확인</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'
    import printJS from 'print-js'
    import commonUtil from "@/mixin/commonUtil";
    
    export default {
        name: 'workingModal',
        mixins: [commonUtil],
        props: {
            title: String,
            prescribe_seq : Number
        },
        data() {
            return {
                prescribeSeq : this.prescribe_seq,
                pharmacyInfo : {},
                pharmacyMedicine : [],
                splitMedList : [],
                cumulative : 0,
            }
        },
        watch : {
            // eslint-disable-next-line no-mixed-spaces-and-tabs
		    prescribe_seq(newValue) {
                console.log("변경 체크");
                //props 변경 여부 확인
                this.prescribeSeq = newValue;
                this.fn_search_prescribe();

            }
        },    
        methods: {
            print() {

                console.log("@@@@@ 출력");
                let param = { "prescribe_seq" : this.prescribeSeq};

                axios
                    .post("/api/admin/work/updatePrescribePrintStatus", param)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                    })
                    .catch((err) => console.log(err));

                printJS({
                    type: 'html',
                    printable: 'printArea',
                    showModal: true,
                    targetStyles: ['*'],
                    style: `
                            @media print {
                            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                            td.highlight-span span { background-color: #e0dcdc!important; }
                            }
                        `
                    //onPrintDialogClose : () => {alert("@@@@@34444");}
                })
            },
            // 처방정보 조회
            fn_search_prescribe(){
                
                this.prescribeSeq = this.prescribe_seq;
                console.log("@@@ this.prescribeSeq : %o",this.prescribeSeq);
                let param = new Object();
                param.prescribe_seq = this.prescribe_seq;

                console.log("@@@ param : %o",param);
                
                axios
                    .post("/api/admin/work/getPharmacyInfo", param)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        this.pharmacyInfo = res.data.pharmacyInfo;
                        this.pharmacyMedicine = res.data.pharmacyMedicineList; 

                        this.fn_water_amount();
                        this.fn_get_date();
                        this.fn_split_medList();
                         
                        //console.log("@@@@ pharmacyInfo : %o",this.pharmacyInfo);
                        //console.log("@@@@ pharmacyMedicine : %o",this.pharmacyMedicine);
                    })
                    .catch((err) => console.log(err));
            },
            //물량계산
            fn_water_amount(){
                //총약재량 = 총조제량 * 첩수
                const totalMedicinQy = this.pharmacyInfo.total_medicine_qnty;

                console.log("@@@@ totalMedicinQy : "+totalMedicinQy);

                //팩수x1팩용량
                const requiredAmount = this.pharmacyInfo.pack_capacity * this.pharmacyInfo.packs_cnt;
                
                //기본 물량 계산 : (팩수x1팩용량 + 총약재용량*1.2)*1.03 + (팩수x1팩용량*0.05) + (총약재용량*0.15) +300 변경 - 20260120
                let waterQy = ((this.pharmacyInfo.pack_capacity * this.pharmacyInfo.packs_cnt*100) + (totalMedicinQy*120))*103 / 10000  + (this.pharmacyInfo.pack_capacity * this.pharmacyInfo.packs_cnt*0.05) + (totalMedicinQy * 0.15) +300;

                //물량 가감 계산
                let waterCount = 0;
                let fixedAdd = false;
                for(let i = 0; i < this.pharmacyMedicine.length ; i++){
                
                    //물 잘먹는 약재
                    if(this.pharmacyMedicine[i].med_hrb_cd == "M000000246" ||
                       this.pharmacyMedicine[i].med_hrb_cd == "M000000020"
                    ){
                        
                        console.log("@@@ 증가 물량 계산 : "+this.pharmacyMedicine[i].medicine_use_qnty *this.pharmacyInfo.prescribe_pack_cnt * 1);
                        //의이인, 건율 : 1g당 투입물량 * 첩수  1ml 추가
                        waterCount = waterCount +  (this.pharmacyMedicine[i].medicine_use_qnty *this.pharmacyInfo.prescribe_pack_cnt * 1); 
                        
                    }else if(this.pharmacyMedicine[i].med_hrb_cd == "M000000450" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000102" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000227" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000355" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000179" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000338" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000404" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000180" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000096" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000400" ){
                        //모려가루, 모려, 용골, 활석, 석결명, 석결명가루, 해표초, 호박, 석고, 망초, 진주모: 1g당 투입물량 * 첩수 1ml 차감
                        //석결명가루 없음

                        console.log("@@@@ waterCount ["+i+"]: "+waterCount);

                        waterCount = waterCount -  (this.pharmacyMedicine[i].medicine_use_qnty * this.pharmacyInfo.prescribe_pack_cnt * 1);    

                        console.log("@@@@ medicine_use_qnty ["+i+"]: "+this.pharmacyMedicine[i].medicine_use_qnty);
                        console.log("@@@@ prescribe_pack_cnt ["+i+"]: "+this.pharmacyInfo.prescribe_pack_cnt);
                        console.log("@@@@ waterCount count ["+i+"]: "+this.pharmacyMedicine[i].medicine_use_qnty * this.pharmacyInfo.prescribe_pack_cnt * 1);
                        
                        
                    }else if(this.pharmacyMedicine[i].med_hrb_cd == "M000000048" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000140" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000065" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000064" ||
                        this.pharmacyMedicine[i].med_hrb_cd == "M000000062" ){
                        //녹용, 별갑, 귀판
                        if(!fixedAdd){
                             waterCount = waterCount + 200;
                             fixedAdd = true;
                        }
                    }
                }
                
                console.log("@@@@ waterQy : "+waterQy);
                

                waterQy = waterQy + waterCount;

                //반올림 제거 - 20260128
                this.pharmacyInfo.amountWater = waterQy;
                this.pharmacyInfo.requiredAmount = requiredAmount;
            },
            fn_get_date(){
                const now = new Date();
                const year = now.getFullYear();
                let month = now.getMonth() + 1;
                if(month < 10){
                    month = "0"+month;
                }

                const day = now.getDate();

                this.pharmacyInfo.currentDay = year+"-"+month+"-"+day;
            },
            fn_split_medList(){

                let printItemList = [];
                for(let i = 0; i < 40; i++){
                    let obj = {};
                    obj.num = i+1;

                    if(this.pharmacyMedicine.length > i){
                        obj.medName = this.pharmacyMedicine[i].med_hrb_nm;
                        obj.useQy = this.pharmacyMedicine[i].medicine_use_qnty;
                        obj.orgPlceNm = this.pharmacyMedicine[i].org_plce_nm;
                        obj.tangen_way = this.pharmacyMedicine[i].tangen_way;
                    }else{
                        obj.medName = '-'
                        obj.useQy = '-'
                        obj.orgPlceNm = ''
                        obj.tangen_way = ''
                    }

                    printItemList.push(obj);
                }


                this.splitMedList = this.fn_splitData(printItemList, 20);
                console.log("@@@@ splitMedList : %o",this.splitMedList);

            },
            fn_splitData(arr, num) {
                let result = [];
                let totalcount = 0;

                for (let i = 0; i < arr.length; i += num) {
                    let tempArray;
                    tempArray = arr.slice(i, i + num);
                    
                    //누적량 계산
                    for(let j = 0; j < tempArray.length; j++){

                        if(tempArray[j].useQy != '-'){
                            totalcount = totalcount + tempArray[j].useQy * this.pharmacyInfo.prescribe_pack_cnt
                            tempArray[j].cumulative = totalcount+' g';
                        }else{
                           tempArray[j].cumulative = '-'; 
                        }
                    }

                    result.push(tempArray);
                }
                return result;
            },
            fn_print_callback(){
                alert("@@@@@1111");                
            },
            fn_close(){
                console.log("@@@@@ 1111");
                this.$bvModal.hide("workingModal"); 
            },
            fn_current_time(){
                const now = new Date()
                const hours = now.getHours()
                const minutes = now.getMinutes().toString().padStart(2, '0') // 항상 두 자리로 표시
                return `${hours}시 ${minutes}분`;
            }
        }
    }
</script>

<style lang="scss" scope>
    @page {
        size: A4;
    }

    @media print {
        * {
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
        }
    }
</style>